import React, { useEffect, useState } from "react";
import Input from "./input";
import { FormContext, iControlProps } from "../types";

type Props = iControlProps & {
    context?: FormContext;
    field_boi_card_name_first?: boolean;
    field_boi_card_name_value?: string;
    field_boi_card_name?: boolean;
    id?: number;
};

const Hidden = ({
    context,
    field_boi_card_name_first: isSurnameFirst,
    field_boi_card_name_value: nameFieldIds,
    field_boi_card_name: shouldGenerateCardName,
    onChange,
    ...props
}: Props) => {
    const [value, setValue] = useState(props.value || "");

    const cardName =
        shouldGenerateCardName &&
        generateCardName(nameFieldIds, isSurnameFirst, context);

    useEffect(() => {
        if (cardName && onChange) {
            setValue(cardName);
            onChange(cardName);
        }
    }, [cardName]);

    return <Input {...props} type="hidden" value={value} />;
};

const generateCardName = (
    nameFieldIds?: string,
    isSurnameFirst?: boolean,
    context?: FormContext
) => {
    if (!nameFieldIds || !context) {
        return "";
    }

    const ids = nameFieldIds
        .trim()
        .slice(1, -1)
        .split(",")
        .map(id => parseInt(id, 10));

    if (ids.length === 1) {
        return context.getValue(`input_${ids[0]}`) || "";
    }

    if (ids.length === 2) {
        const first = context.getValue(`input_${ids[0]}`) || "";
        const last = context.getValue(`input_${ids[1]}`) || "";

        const cardName = isSurnameFirst ? `${last} ${first}` : `${first} ${last}`;
        return cardName.trim();
    }

    return "";
};

export default Hidden;
